/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../../contexts/userContext";
import { usePolicyService } from '../../../services/policyService.js';

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as EditPolicySvg } from '../../../resources/images/aa-create-policy.svg';

/* Styles */
import styles from "./styles";

const EditPolicyModal = ({showModal, setShowModal, policyName, policyId, setPolicyResponse}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();

  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId

  const [policyNameError, setPolicyNameError] = useState(false);
  const [genericError, setGenericError] = useState(false);
  
  const { editPolicyName } = usePolicyService({
    onError() {
      setPolicyNameError(true)
    },
  });

  const handleEditPolicyName = async (values) => {
    const response = await editPolicyName(values, setPolicyResponse)
   if ((response.statusCode === "ERROR" || response.errors) && (  response?.errors[0]?.errorCode === '8001' || response?.errors[0]?.errorCode === '8000')) {
      setPolicyNameError(true)
    } else if (response) {
      setShowModal(false)
    }
  }

  const resetErrorMessages = () => {
    setPolicyNameError(false)
    setGenericError(false)
  }

  return (
      <UCModal
        className={classes.editPolicyModal}
        showModal={ showModal }
        setShowModal={ setShowModal }
        modalIcon={ <EditPolicySvg /> }
        modalTitle={ <FormattedMessage id="editPolicy.title"/> }
        modalDescription={ <FormattedMessage id="editPolicy.description"/> }
        modalContent={ 
          <Content 
            setShowModal={setShowModal} 
            handleEditPolicyName={handleEditPolicyName} 
            companyEntityId={companyEntityId} 
            policyNameError={policyNameError} 
            policyName={policyName} 
            policyId={policyId}
            genericError={genericError}
            resetErrorMessages={resetErrorMessages}
          /> 
        }
        dataTestId="editPolicyModal"
        onExited={() => resetErrorMessages()}
      />
  )
}

export default EditPolicyModal;